/**
 * Application-wide constants
 * These values should not be modified at runtime
 */

/**
 * Admin user UUID for agentur@vivu.at
 * Used for admin checks throughout the application
 * This replaces hardcoded email checks for security
 */
export const VIVU_ADMIN_USER_ID = '42953740-f1e8-42e0-8e44-6bdd32ffd711';

/**
 * Admin email (legacy - prefer using VIVU_ADMIN_USER_ID)
 * @deprecated Use VIVU_ADMIN_USER_ID for admin checks instead
 */
export const VIVU_ADMIN_EMAIL = 'agentur@vivu.at';

/**
 * Company display name for VIVU
 */
export const VIVU_COMPANY_NAME = 'VIVU Finanz & Versicherungsagentur GmbH';
